const $ = require("jquery");

module.exports = class ChiliPiperMetrics {
  constructor (email /* string */) {
    this.interval = null;
    this.email = email;

    this.googleFormUrl = "https://docs.google.com/forms/u/1/d/e/1FAIpQLSerfazn73x5eUpQTT2rZXnFEiDptcAXn3VWe6PuHD9Jaq44Hg/formResponse";
  }

  async submitMetric () {
    const body = new FormData();
    body.append("entry.1662012973", this.email);

    await fetch(this.googleFormUrl, {
      method: "POST",
      body,
    });
  }

  start () {
    this.interval = setInterval(() => {
      if ($(".chilipiper-popup").length === 0) {
        return;
      }

      clearInterval(this.interval);

      this.submitMetric();
    }, 300);
  }
}
